import { Avatar, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import { COLORS, SCAN_STATUS, SCAN_STATUS_LETTER } from '../../constants/scan-status';

const useStyles = makeStyles(() => ({
    root: {
        height: 30,
        width: 30,
        background: 'black',
        color: 'white',
        fontSize: 16
    },
    [SCAN_STATUS.ASSET_FOUND_BUT_MOVED]: {
        background: COLORS[SCAN_STATUS.ASSET_FOUND_BUT_MOVED]
    },
    [SCAN_STATUS.NEW_TAG]: {
        background: COLORS[SCAN_STATUS.NEW_TAG]
    },
    [SCAN_STATUS.ASSET_FOUND]: {
        background: COLORS[SCAN_STATUS.ASSET_FOUND]
    },
    [SCAN_STATUS.NOT_SCANNED]: {
        background: COLORS[SCAN_STATUS.NOT_SCANNED]
    }
}));

const ContainerScanResultAvatar = ({ status }) => {
    const classes = useStyles();

    return (
        <Avatar variant='rounded' className={clsx(classes.root, classes[status])}>
            {SCAN_STATUS_LETTER[status]}
        </Avatar>
    );
};

export default ContainerScanResultAvatar;
